import React, {useState} from "react";
import TopBar from "./globalComponents/topbar";
import Footer from "./globalComponents/footer";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 1300,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 606,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							position: "relative",
						}}>
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						
					</div>
					<TopBar/>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Mentors"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 38,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 42,
							}} >
							{"Explore all mentors"}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							marginRight: 6,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Mentors"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #00AEEF`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pd3z6644_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#0BBB0D",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Available"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 105,
											}} >
											{"Jenny Wilson"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iwuuxu49_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7gtwy8hf_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gezjya85_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7z9whipv_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3nm8vxey_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#EEBD10",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Limited Availability"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 108,
											}} >
											{"Guy Hawkins"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dfdwuozr_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/r82f2oae_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kjaeiix9_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/i4n855ww_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fh3hw5iq_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FF3737",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Unavailable"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 126,
											}} >
											{"Robert Fox"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/e69kiws8_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/34uozfwv_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gaybvd7j_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8dqzfbxk_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/73di6za5_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#0BBB0D",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Available"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 97,
											}} >
											{"Bessie Cooper"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/z9vtjb7z_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8pydqv1p_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/qpauwcba_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3jiv5rk4_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 743,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Mentor Profile"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 29,
									gap: 20,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										position: "relative",
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dcizlv6y_expires_30_days.png"} 
										style={{
											width: 80,
											height: 80,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											position: "absolute",
											bottom: -6,
											left: 12,
											width: 56,
											display: "flex",
											flexDirection: "column",
											background: "#0BBB0D",
											borderRadius: 4,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 10,
												fontWeight: "bold",
												textAlign: "center",
												marginTop: 2,
												marginBottom: 2,
												marginLeft: 6,
												marginRight: 6,
											}} >
											{"Available"}
										</span>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											marginBottom: 8,
										}} >
										{"Jenny Wilson"}
									</span>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											paddingRight: 1,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5w35u8mc_expires_30_days.png"} 
											style={{
												width: 12,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"New York City, USA"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#1074BC",
									borderRadius: 8,
									paddingTop: 13,
									marginBottom: 17,
									gap: 9,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 35,
										marginRight: 35,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 14,
											marginTop: 1,
											marginBottom: 1,
											marginRight: 48,
										}} >
										{"Expertise"}
									</span>
									<span 
										style={{
											color: "#E7F1F8",
											fontSize: 14,
											fontWeight: "bold",
											marginRight: 46,
										}} >
										{"Experience"}
									</span>
									<span 
										style={{
											color: "#E7F1F8",
											fontSize: 14,
											marginTop: 1,
											marginBottom: 1,
										}} >
										{"Availability"}
									</span>
								</div>
								<div 
									style={{
										alignSelf: "stretch",
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
									}}>
									<div 
										style={{
											width: 65,
											height: 3,
											background: "#FFFFFF",
											borderTopLeftRadius: 8,
											borderTopRightRadius: 9,
											boxShadow: "0px 1px 2px #00000012",
										}}>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 16,
									gap: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0xomc1ps_expires_30_days.png"} 
									style={{
										width: 49,
										height: 49,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 4,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Harvard University"}
									</span>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 12,
										}} >
										{"April 2022 - Present"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 1,
									marginLeft: 20,
									gap: 40,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jg95lybj_expires_30_days.png"} 
									style={{
										width: 9,
										height: 9,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Senior Teacher"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 1,
									marginLeft: 23,
									marginRight: 23,
									gap: 43,
								}}>
								<div 
									style={{
										width: 3,
										height: 66,
										background: "#9DC6E4",
									}}>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 3,
										gap: 4,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"April 2023 - Present • 1 Year"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Massachusetts Hall, Cambridge, MA 02138, USA"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 4,
									marginLeft: 20,
									gap: 40,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ed9mviul_expires_30_days.png"} 
									style={{
										width: 9,
										height: 9,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Teacher"}
								</span>
							</div>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 12,
									marginBottom: 4,
									marginLeft: 69,
								}} >
								{"April 2022 - April 2023 • 1 Year"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 12,
									marginBottom: 20,
									marginLeft: 69,
								}} >
								{"Massachusetts Hall, Cambridge, MA 02138, USA"}
							</span>
							<div 
								style={{
									width: 293,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
									marginLeft: 69,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
									marginLeft: 5,
									marginRight: 5,
									gap: 25,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jhmnz2vt_expires_30_days.png"} 
									style={{
										width: 39,
										height: 49,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 4,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Teacher at Oxford University"}
									</span>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 12,
										}} >
										{"Mar 2021 - April 2022 • 1 Year"}
									</span>
								</div>
							</div>
							<div 
								style={{
									width: 293,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
									marginLeft: 69,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									border: `1px solid #00000000`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 82,
									paddingRight: 83,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fw6bhhsq_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Send Connection Request"}
								</span>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 743,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Send Connection Request"}
							</span>
							<div 
								style={{
									width: 277,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
										marginBottom: 20,
									}} >
									{"Learning Goals:"}
								</span>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 12,
										fontWeight: "bold",
										marginBottom: 12,
									}} >
									{"Goal"}
								</span>
								<input
									placeholder={"Select goal"}
									value={input2}
									onChange={(event)=>onChangeInput2(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginBottom: 20,
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 20,
										paddingRight: 20,
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 12,
										fontWeight: "bold",
										marginBottom: 12,
									}} >
									{"Description (optional)"}
								</span>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 67,
										paddingLeft: 20,
										paddingRight: 136,
										marginBottom: 24,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
										}} >
										{"Enter description..."}
									</span>
								</div>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 20,
									}} >
									{"Areas of Interest:"}
								</span>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 50,
										paddingLeft: 20,
										paddingRight: 20,
										marginBottom: 24,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											width: 230,
										}} >
										{"How to secure seed funding for my startup?"}
									</span>
								</div>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 20,
										width: 196,
									}} >
									{"Preferred Communication Frequency:"}
								</span>
								<button 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 15,
										paddingBottom: 15,
										paddingLeft: 20,
										paddingRight: 20,
										marginBottom: 24,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginTop: 1,
											marginBottom: 1,
											marginRight: 118,
										}} >
										{"Select frequency"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/on977vsk_expires_30_days.png"} 
										style={{
											width: 17,
											height: 17,
											objectFit: "fill",
										}}
									/>
								</button>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 8,
										border: `1px solid #00000000`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 40,
										paddingRight: 41,
										gap: 6,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gircciqv_expires_30_days.png"} 
										style={{
											width: 17,
											height: 17,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Send Connection Request"}
									</span>
								</div>
							</div>
						</div>
					</div>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
						}}>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/q3rk6f0a_expires_30_days.png"} 
							style={{
								width: 7,
								height: 17,
								objectFit: "fill",
							}}
						/>
					</div>
				</div>
			</div>
			<Footer/>
		</div>
	)
}